// import React, { useEffect } from "react";
// import { NotificationContainer } from "react-notifications";
// import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// import Pages from "views/pages";
// import "./style.scss";
// import { checkApproveStaking } from "service";

// const App = () => {
//   useEffect(() => {
//     setInterval(async () => {
//       let data = await checkApproveStaking();
//       console.log(data);

//     }, 1000);
//   }, []);

//   return (
//     <BrowserRouter>
//       <NotificationContainer />
//       <Switch>
//         <Route path={"/"} component={Pages} />
//         <Redirect from={"*"} to={"/"} />
//       </Switch>
//     </BrowserRouter>
//   );
// };

// export default App;


import React, { useEffect, useRef } from "react";
import { NotificationContainer } from "react-notifications";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Pages from "views/pages";
import "./style.scss";
import { checkApproveStaking } from "service";

const App = () => {
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await checkApproveStaking();
        if (!data) {
          return
        }
        window.localStorage.setItem("sttApprove", data.stt);
        window.localStorage.setItem("balance", data.balance)
        // console.log(data);
      } catch (error) {
        console.error("Error checking staking approval:", error);
      }
    };

    intervalRef.current = setInterval(fetchData, 1000);

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  return (
    // <BrowserRouter>
    //   <NotificationContainer />
    //   <Switch>
    //     <Route exact path="/" component={Pages} />
    //     <Redirect to="/" />
    //   </Switch>
    // </BrowserRouter>
    <BrowserRouter>
      <NotificationContainer />
      <Pages />
    </BrowserRouter>
  );
};

export default App;